import React from 'react';
import '../static/css/submit.css';
import {category} from '../config/category';
import axios from 'axios';
import NotificationSystem from 'react-notification-system';
import {withRouter} from "react-router-dom";

const _userId = JSON.parse(localStorage.getItem('UserObject'));

class SubmitAdd extends React.Component {
    _notificationSystem = null

    constructor(props) {
        super(props);
        this.state = {
            allcategory: category,
            selectindex: undefined,
            condition: true,
            img1: '',
            img2: '',
            img3: '',
            img4: ''


        };
    }

    //this will make you in contact with home after log in.

    onchange = (event) => {
        event.preventDefault();

        switch (event.target.name) {

            case 'img1':
                this.setState({img1: event.target.files[0].name});
                break;
            case 'img2':
                this.setState({img2: event.target.files[0].name});
                break;
            case 'img3':
                this.setState({img3: event.target.files[0].name});
                break;
            case 'img4':
                this.setState({img4: event.target.files[0].name});
                break;

            default:
                break;
        }


    };

    // Notification

    componentWillMount() {
        if (_userId === null) {
            window.location = '/user/login';
        }
    }

    _addNotification = (level, msg) => {

        this._notificationSystem.addNotification({
            message: msg,
            level: level
        });
    };

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }

    // Axios Request
    postAdd = (e) => {
        e.preventDefault();
        const {city, country} = this.state;
        let form = document.getElementById('addform')
        let formData = new FormData(form);
        formData.append('city', city);
        formData.append('country', country);
        if (this.props.match.path === '/posting') {

            axios.post(`${process.env.REACT_APP_BACKEND_URL}/item/ads`, formData).then(res => {
                console.log(res.data);

                this._addNotification("success", "Your ad successfully upload.");
                window.location = '/';
            })
                .catch(err => {
                    console.log(err.response);
                    this._addNotification("error", "You have an error in your form please check and resubmit again.")
                });
        } else {
            let path = this.props.match.params.id;
            axios.put(`${process.env.REACT_APP_BACKEND_URL}/item/ads/update/?id=` + path, formData).then(res => {
                console.log(res.data);

                this._addNotification("success", "Your ad successfully updated.");
                window.location = '/';
            })
                .catch(err => {
                    console.log(err.response);
                    this._addNotification("error", "You have an error in your form please check and resubmit again.")
                });
        }

    }
    searchLocation = () => {
        let input = document.getElementById('location');
        let options = {
            types: ['(cities)'],
            // componentRestrictions: {country: "eu"}
        };
        let autocomplete = new window.google.maps.places.Autocomplete(input);

        // Bind the map's bounds (viewport) property to the autocomplete object,
        // so that the autocomplete requests use the current map bounds for the
        // bounds option in the request.
        // Set the data fields to return when the user selects a place.
        autocomplete.setFields(
            ['address_components', 'geometry', 'icon', 'name']);

        autocomplete.addListener('place_changed', () => {
            let place = autocomplete.getPlace();
            console.log('places', place)
            if (!place.geometry) {
                // User entered the name of a Place that was not suggested and
                // pressed the Enter key, or the Place Details request failed.
                window.alert("No details available for input: '" + place.name + "'");
                return;
            }

            let address = '';
            if (place.address_components) {
                address = [
                    (place.address_components[0] && place.address_components[0].long_name || ''),
                    (place.address_components[1] && place.address_components[1].long_name || ''),
                    (place.address_components[2] && place.address_components[2].long_name || '')
                ].join(' ');
            }
            this.setState({
                city: place.name,
                country: place.address_components[4] ? place.address_components[4].long_name :
                    place.address_components[3].long_name
            })
            console.log('address', address)
        });

    }
    // Selected Category against result
    selectCategory = () => {
        let selectBox = document.getElementById("selectcate");
        let selectedValue = selectBox.options[selectBox.selectedIndex].value;
        if (selectedValue === 'Animals' || selectedValue === 'Services') {
            this.setState({
                condition: false
            });
        } else {
            this.setState({
                condition: true
            })
        }


    }

    // Selected province index
    selectedindex = () => {
        let selectBox = document.getElementById("selectBox");
        let selectedValue = selectBox.options[selectBox.selectedIndex].value;

        this.setState({
            selectindex: selectedValue,
        });

    }

    //title, categoryname, price, condition, description,
    // photos, name, phone, selectprovince, selectcity
    render() {
        const {
            selectindex, allcities, allprovince, allcategory
        } = this.state;
        return (
            <div>
                <div id="container" className="container">
                    <div id="subbox">
                        <p>Post Ad</p>
                        <div id="submitform">
                            <form id="addform" encType="multipart/form-data" onSubmit={this.postAdd}>
                                <input type="hidden" name="_userId" defaultValue={_userId._id}/>
                                <label><b>Title of Ad</b><span style={{color: 'red'}}>*</span></label>
                                <input type="text" id="title"
                                       className="form-control" name="title" required maxLength='70'/>
                                <small id="title" className="form-text text-muted">Maximum 120 characters</small>
                                <br/><br/>
                                <label><b>Category</b><span style={{color: 'red'}}>*</span></label>
                                <select id="selectcate"
                                        onChange={this.selectCategory}

                                        className="form-control" required name="category">
                                    <option value=''>Select Category</option>
                                    {allcategory.map((item) => {
                                        return (
                                            <option value={item.cate} key={item.cate}>{item.cate}</option>
                                        );
                                    })}


                                </select>

                                <hr/>

                                <label><b>Price</b>
                                    <span style={{color: 'red'}}>*</span>
                                </label>

                                <input type="text" id="price"
                                       name="price" className="form-control" placeholder="Pounds" required/>
                                <br/>

                                {this.state.condition ?
                                    <div>
                                        <label><b>Condition</b><span style={{color: 'red'}}>*</span></label>
                                        <select className="form-control" id="selectcon"
                                                required name="condition">
                                            <option value=''>Choose</option>
                                            <option value='new'>New</option>
                                            <option value='used'>Used</option>
                                        </select>
                                    </div> : ''}
                                <br/>
                                <label>
                                    <b>Ad Description</b>
                                    <span style={{color: 'red'}}>*</span>
                                </label>
                                <textarea cols={60} rows={8}
                                          className="form-control" name="description"
                                          placeholder="Including the brand, model, age, KM's and any other accessories"
                                          required>
                                </textarea>
                                <br/> <br/>

                                <label><b>Upload Photos</b><span style={{color: 'red'}}>*</span></label>

                                <div className="custom-file mb-3">
                                    <input type="file" className="custom-file-input" onChange={this.onchange}
                                           name="img1" id="img1" required/>
                                    <label htmlFor="img1" className="custom-file-label">{this.state.img1}</label>
                                </div>
                                <div className="custom-file mb-3">
                                    <input type="file" className="custom-file-input" onChange={this.onchange}
                                           name="img2" id="img2" required/>
                                    <label htmlFor="img2" className="custom-file-label">{this.state.img2}</label>
                                </div>
                                <div className="custom-file mb-3">
                                    <input type="file" className="custom-file-input" onChange={this.onchange}
                                           name="img3" id="img3" required/>
                                    <label htmlFor="img3" className="custom-file-label">{this.state.img3}</label>
                                </div>
                                <div className="custom-file mb-3">
                                    <input type="file" className="custom-file-input" onChange={this.onchange}
                                           name="img4" id="img4"/>
                                    <label htmlFor="img4" className="custom-file-label">{this.state.img4}</label>
                                </div>


                                <hr/>
                                <label><b>Name</b><span style={{color: 'red'}}>*</span></label>
                                <input type="text" id="name"

                                       name="name" className="form-control" required/><br/>
                                <label><b>Phone number</b><span style={{color: 'red'}}>*</span></label>
                                <input type="text" id="phone"


                                       name="phone" className="form-control" placeholder="+44" required/><br/>
                                <hr/>
                                <label><b>Location</b><span style={{color: 'red'}}>*</span></label>
                                <div className="row">
                                    <div className=" col-md-8 col-lg-8" id="iconform">
                                        <input type="text" className="form-control" id="location"
                                               onKeyPress={this.searchLocation}
                                               placeholder="All Europe"/>
                                        <i className="fa fa-map-marker-alt"/>
                                    </div>

                                </div>
                                {/*<label><b>Province</b><span style={{color: 'red'}}>*</span></label>*/}
                                {/*<select id="selectBox" name="province" onChange={this.selectedindex}*/}
                                {/*        className="form-control" required>*/}
                                {/*    <option value={null}>Choose Province</option>*/}
                                {/*    {allprovince.map((item) => {*/}
                                {/*        return (*/}
                                {/*            <option value={item} key={item}>{item}</option>*/}
                                {/*        );*/}

                                {/*    })*/}

                                {/*    }*/}
                                {/*</select><br/>*/}

                                {/*{(selectindex === undefined ? '' :*/}
                                {/*        <div>*/}
                                {/*            <label><b>Cities</b><span style={{color: 'red'}}>*</span></label>*/}

                                {/*            <select className="form-control" id="selectcity"*/}

                                {/*                    name="city" required>*/}
                                {/*                <option value=''>Choose Province</option>*/}

                                {/*                {selectindex !== undefined && allcities[selectindex].map((item) => {*/}


                                {/*                    return (*/}
                                {/*                        <option value={item.city} key={item.city}>{item.city}</option>*/}
                                {/*                    )*/}
                                {/*                })}*/}
                                {/*            </select>*/}
                                {/*        </div>*/}
                                {/*)}*/}
                                <p id="agreement">By clicking 'Submit' you confirm that you have carefully read and
                                    understood all the facts, statements and conditions stated in the Terms of Use &
                                    Posting Rules of our website to which you unconditionally agree and accept as true
                                    and correct and constituting a binding agreement between us.</p>
                                <hr/>
                                <input type="submit" name="submit" value="Submit" className="btn btn-warning btn-lg"/>
                            </form>
                        </div>

                    </div>
                </div>
                <NotificationSystem ref="notificationSystem"/>
            </div>

        );
    }
}

export default withRouter(SubmitAdd);






// WEBPACK FOOTER //
// ./src/components/submitadd.js